module.exports = __webpack_public_path__ + "img/piligrim.ce24d38d.png";